import { Box, Stack } from '@mui/material';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useOffersSearchParams } from '../email-pulse.hooks';
import EmailPulseHeader from '../email-pulse-header/email-pulse-header.component';
import OffersSummaryCards from './offers-summary-cards.component';
import ApiDetailsDrawer from '../email-pulse-api-definitions/api-details-drawer.component';
import {
  useGetEmailPulseOffersSummaryQuery,
  useGetEmailPulseOffersEmailsOpenedBreakdownQuery,
  useGetEmailPulseOffersEmailsBouncedBreakdownQuery,
  useGetEmailPulseOffersDataQuery,
  useExportEmailPulseOffersMutation,
} from 'api/reports-service/email-pulse-hooks';
import OffersDataGrid from './offers-data-grid/offers-data-grid.component';
import { transformEmailPulseDataGridResponse } from '../email-pulse.utils';

const filteredSearchParams = ['messageIds', 'emailType'];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useOffersSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <Offers />
    </SearchParamsProvider>
  );
};

const Offers = () => {
  const { open, close, isOpen } = useDrawer();

  const offersSummary = useSearchQuery(useGetEmailPulseOffersSummaryQuery, {
    filteredSearchParams,
  });

  const emailsOpenedBreakdown = useSearchQuery(
    useGetEmailPulseOffersEmailsOpenedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const emailsBouncedBreakdown = useSearchQuery(
    useGetEmailPulseOffersEmailsBouncedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const offersDataGrid = useSearchQuery(useGetEmailPulseOffersDataQuery, {
    filteredSearchParams,
    getSearchResults: response =>
      transformEmailPulseDataGridResponse(response, 'id', 'offerTitle'),
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            marketingSummary: offersSummary,
            emailsOpenedBreakdown,
            emailsBouncedBreakdown,
            marketingDataGrid: offersDataGrid,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />
          <EmailPulseHeader open={open} />

          {/* Summary Cards */}
          <OffersSummaryCards />

          {/* Data Grid */}
          <Box height={{ xs: 400, sm: 600 }}>
            <OffersDataGrid
              data-testid="Offers.OffersDataGrid"
              queryName="marketingDataGrid"
              useExportMutation={useExportEmailPulseOffersMutation}
            />
          </Box>
        </Stack>
      </MultipleSearchQueryProvider>
      <ApiDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
